import React from "react"
import "./contentslider.scss";
import {KeenSliderInstance, KeenSliderPlugin, useKeenSlider,} from "keen-slider/react"
import "keen-slider/keen-slider.min.css"
import LineIndicator from "../../lineindicator/lineindicator";
import Contents from "./contents/contents";
import {ContentsSlide} from "../../../modals/types/content";

function ThumbnailPlugin(
    //@ts-ignore
    mainRef: MutableRefObject<KeenSliderInstance | null>
): KeenSliderPlugin {
    return (slider) => {
        function removeActive() {
            slider.slides.forEach((slide) => {
                slide.classList.remove("active")
            })
        }

        function addActive(idx: number) {
            slider.slides[idx].classList.add("active")
        }

        function addClickEvents() {
            slider.slides.forEach((slide, idx) => {
                slide.addEventListener("click", () => {
                    if (mainRef.current) mainRef.current.moveToIdx(idx)
                })
            })
        }

        slider.on("created", () => {
            if (!mainRef.current) return
            addActive(slider.track.details.rel)
            addClickEvents()
            //@ts-ignore
            mainRef.current.on("animationStarted", (main) => {
                removeActive()
                const next = main.animator.targetIdx || 0
                addActive(main.track.absToRel(next))
                slider.moveToIdx(Math.min(slider.track.details.maxIdx, next))
            })
        })
    }
}

interface IContentsSlider {
    data: ContentsSlide[]
}

export default function ContentSlider({data}: IContentsSlider) {
    const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
        initial: 0,
    })
    const [thumbnailRef] = useKeenSlider<HTMLDivElement>(
        {
            initial: 0,
            slides: {
                perView: 4,
                spacing: 0,
            },
            rtl: true,
            breakpoints: {
                '(max-width: 1200px)': {
                    slides: {
                        perView: 3,
                        spacing: 5,
                    }
                }, '(max-width: 992px)': {
                    slides: {
                        perView: 2,
                        spacing: 0,
                    }
                }, '(max-width: 768px)': {
                    slides: {
                        perView: 1,
                        spacing: 0,
                    }
                },
            },
        },
        [ThumbnailPlugin(instanceRef)]
    )

    return (
        <div className="Content-Slider">
            <div className="Content-Slider-Header">
                <div className="d-flex justify-content-start">
                    <LineIndicator/>
                    <h3>
                        <span className="red-text">آخرین</span>
                        <span> مقالات ما </span>
                    </h3>
                </div>
                <div className="Navigation-Buttons">
                    <div onClick={() => {
                        instanceRef?.current?.prev();
                    }} className="Navigate-Right">
                        <img src={require("../../../assets/images/icons/RightArrow.svg").default} alt="" className=""/>
                    </div>
                    <div onClick={() => {
                        instanceRef?.current?.next();
                    }} className="Navigate-Left">
                        <img src={require("../../../assets/images/icons/LeftArrow.svg").default} alt="" className=""/>
                    </div>
                </div>
            </div>
            <div className="Content-Slider-Box">
                <div ref={sliderRef} className="keen-slider">
                    {
                        data.map((item, index) => {
                            return (
                                <div key={index} className="keen-slider__slide">
                                    <Contents image={item.image} title={item.title} author={item.author}
                                              date={item.date} desc={item.desc}/>
                                </div>
                            );
                        })
                    }
                </div>
                <div className="Content-Slider-Thumbnail">
                    <div ref={thumbnailRef} className="keen-slider thumbnail">
                        {
                            data.map((item, index) => {
                                return (
                                    <div key={index} className="keen-slider__slide">
                                        <div className="Slider-Active Slider-Active-Top">
                                            <img
                                                src={require("../../../assets/images/icons/SliderActiveTop.svg").default}
                                                alt="" className=""/>
                                        </div>
                                        <img src={item.image} alt="" className="img-fluid thumbnail-image"/>
                                        <div className="Slider-Active Slider-Active-Bottom">
                                            <img
                                                src={require("../../../assets/images/icons/SliderActiveBottom.svg").default}
                                                alt="" className=""/>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}
